<app-nav *ngIf="showMenu"></app-nav>

<main [class.noMargin]="!showMenu">
  <router-outlet></router-outlet>
</main>
